import { render, staticRenderFns } from "./ReadNext.vue?vue&type=template&id=2602cdfb&"
import script from "./ReadNext.vue?vue&type=script&lang=js&"
export * from "./ReadNext.vue?vue&type=script&lang=js&"
import style0 from "./ReadNext.vue?vue&type=style&index=0&id=2602cdfb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports